import { putExceptional } from "@/common/character/exceptional";

export interface ExceptionalStore {
  exceptionalAgility: number;
  exceptionalCharisma: number;
  exceptionalHealth: number;
  exceptionalIntelligence: number;
  exceptionalPerception: number;
  exceptionalPower: number;
  exceptionalStrength: number;
  exceptionalWillpower: number;
  tempExceptionalAgility: number;
  tempExceptionalCharisma: number;
  tempExceptionalHealth: number;
  tempExceptionalIntelligence: number;
  tempExceptionalPerception: number;
  tempExceptionalPower: number;
  tempExceptionalStrength: number;
  tempExceptionalWillpower: number;
  exceptionalAgilityId: number;
  exceptionalCharismaId: number;
  exceptionalHealthId: number;
  exceptionalIntelligenceId: number;
  exceptionalPerceptionId: number;
  exceptionalPowerId: number;
  exceptionalStrengthId: number;
  exceptionalWillpowerId: number;
  tempExceptionalAgilityId: number;
  tempExceptionalCharismaId: number;
  tempExceptionalHealthId: number;
  tempExceptionalIntelligenceId: number;
  tempExceptionalPerceptionId: number;
  tempExceptionalPowerId: number;
  tempExceptionalStrengthId: number;
  tempExceptionalWillpowerId: number;
}

export default {
  namespaced: true,
  state: (): ExceptionalStore => ({
    exceptionalAgility: 0,
    exceptionalCharisma: 0,
    exceptionalHealth: 0,
    exceptionalIntelligence: 0,
    exceptionalPerception: 0,
    exceptionalPower: 0,
    exceptionalStrength: 0,
    exceptionalWillpower: 0,
    tempExceptionalAgility: 0,
    tempExceptionalCharisma: 0,
    tempExceptionalHealth: 0,
    tempExceptionalIntelligence: 0,
    tempExceptionalPerception: 0,
    tempExceptionalPower: 0,
    tempExceptionalStrength: 0,
    tempExceptionalWillpower: 0,
    exceptionalAgilityId: 0,
    exceptionalCharismaId: 0,
    exceptionalHealthId: 0,
    exceptionalIntelligenceId: 0,
    exceptionalPerceptionId: 0,
    exceptionalPowerId: 0,
    exceptionalStrengthId: 0,
    exceptionalWillpowerId: 0,
    tempExceptionalAgilityId: 0,
    tempExceptionalCharismaId: 0,
    tempExceptionalHealthId: 0,
    tempExceptionalIntelligenceId: 0,
    tempExceptionalPerceptionId: 0,
    tempExceptionalPowerId: 0,
    tempExceptionalStrengthId: 0,
    tempExceptionalWillpowerId: 0,
  }),
  getters: {
    tempExceptionalAgility: (state: ExceptionalStore) => {
      return state.tempExceptionalAgility;
    },
    tempExceptionalCharisma: (state: ExceptionalStore) => {
      return state.tempExceptionalCharisma;
    },
    tempExceptionalHealth: (state: ExceptionalStore) => {
      return state.tempExceptionalHealth;
    },
    tempExceptionalIntelligence: (state: ExceptionalStore) => {
      return state.tempExceptionalIntelligence;
    },
    tempExceptionalPerception: (state: ExceptionalStore) => {
      return state.tempExceptionalPerception;
    },
    tempExceptionalPower: (state: ExceptionalStore) => {
      return state.tempExceptionalPower;
    },
    tempExceptionalStrength: (state: ExceptionalStore) => {
      return state.tempExceptionalStrength;
    },
    tempExceptionalWillpower: (state: ExceptionalStore) => {
      return state.tempExceptionalWillpower;
    },
    exceptionalAgility: (state: ExceptionalStore) => {
      return state.exceptionalAgility;
    },
    exceptionalCharisma: (state: ExceptionalStore) => {
      return state.exceptionalCharisma;
    },
    exceptionalHealth: (state: ExceptionalStore) => {
      return state.exceptionalHealth;
    },
    exceptionalIntelligence: (state: ExceptionalStore) => {
      return state.exceptionalIntelligence;
    },
    exceptionalPerception: (state: ExceptionalStore) => {
      return state.exceptionalPerception;
    },
    exceptionalPower: (state: ExceptionalStore) => {
      return state.exceptionalPower;
    },
    exceptionalStrength: (state: ExceptionalStore) => {
      return state.exceptionalStrength;
    },
    exceptionalWillpower: (state: ExceptionalStore) => {
      return state.exceptionalWillpower;
    },
    tempExceptionalAgilityId: (state: ExceptionalStore) => {
      return state.tempExceptionalAgilityId;
    },
    tempExceptionalCharismaId: (state: ExceptionalStore) => {
      return state.tempExceptionalCharismaId;
    },
    tempExceptionalHealthId: (state: ExceptionalStore) => {
      return state.tempExceptionalHealthId;
    },
    tempExceptionalIntelligenceId: (state: ExceptionalStore) => {
      return state.tempExceptionalIntelligenceId;
    },
    tempExceptionalPerceptionId: (state: ExceptionalStore) => {
      return state.tempExceptionalPerceptionId;
    },
    tempExceptionalPowerId: (state: ExceptionalStore) => {
      return state.tempExceptionalPowerId;
    },
    tempExceptionalStrengthId: (state: ExceptionalStore) => {
      return state.tempExceptionalStrengthId;
    },
    tempExceptionalWillpowerId: (state: ExceptionalStore) => {
      return state.tempExceptionalWillpowerId;
    },
    exceptionalAgilityId: (state: ExceptionalStore) => {
      return state.exceptionalAgilityId;
    },
    exceptionalCharismaId: (state: ExceptionalStore) => {
      return state.exceptionalCharismaId;
    },
    exceptionalHealthId: (state: ExceptionalStore) => {
      return state.exceptionalHealthId;
    },
    exceptionalIntelligenceId: (state: ExceptionalStore) => {
      return state.exceptionalIntelligenceId;
    },
    exceptionalPerceptionId: (state: ExceptionalStore) => {
      return state.exceptionalPerceptionId;
    },
    exceptionalPowerId: (state: ExceptionalStore) => {
      return state.exceptionalPowerId;
    },
    exceptionalStrengthId: (state: ExceptionalStore) => {
      return state.exceptionalStrengthId;
    },
    exceptionalWillpowerId: (state: ExceptionalStore) => {
      return state.exceptionalWillpowerId;
    },
  },
  mutations: {
    setExceptionals: (
      state: ExceptionalStore,
      newData: {
        exceptionalAgility: number;
        exceptionalCharisma: number;
        exceptionalHealth: number;
        exceptionalIntelligence: number;
        exceptionalPerception: number;
        exceptionalPower: number;
        exceptionalStrength: number;
        exceptionalWillpower: number;
        tempExceptionalAgility: number;
        tempExceptionalCharisma: number;
        tempExceptionalHealth: number;
        tempExceptionalIntelligence: number;
        tempExceptionalPerception: number;
        tempExceptionalPower: number;
        tempExceptionalStrength: number;
        tempExceptionalWillpower: number;
        exceptionalAgilityId: number;
        exceptionalCharismaId: number;
        exceptionalHealthId: number;
        exceptionalIntelligenceId: number;
        exceptionalPerceptionId: number;
        exceptionalPowerId: number;
        exceptionalStrengthId: number;
        exceptionalWillpowerId: number;
        tempExceptionalAgilityId: number;
        tempExceptionalCharismaId: number;
        tempExceptionalHealthId: number;
        tempExceptionalIntelligenceId: number;
        tempExceptionalPerceptionId: number;
        tempExceptionalPowerId: number;
        tempExceptionalStrengthId: number;
        tempExceptionalWillpowerId: number;
      }
    ) => {
      state.exceptionalAgility = newData.exceptionalAgility;
      state.exceptionalCharisma = newData.exceptionalCharisma;
      state.exceptionalHealth = newData.exceptionalHealth;
      state.exceptionalIntelligence = newData.exceptionalIntelligence;
      state.exceptionalPerception = newData.exceptionalPerception;
      state.exceptionalPower = newData.exceptionalPower;
      state.exceptionalStrength = newData.exceptionalStrength;
      state.exceptionalWillpower = newData.exceptionalWillpower;
      state.tempExceptionalAgility = newData.tempExceptionalAgility;
      state.tempExceptionalCharisma = newData.tempExceptionalCharisma;
      state.tempExceptionalHealth = newData.tempExceptionalHealth;
      state.tempExceptionalIntelligence = newData.tempExceptionalIntelligence;
      state.tempExceptionalPerception = newData.tempExceptionalPerception;
      state.tempExceptionalPower = newData.tempExceptionalPower;
      state.tempExceptionalStrength = newData.tempExceptionalStrength;
      state.tempExceptionalWillpower = newData.tempExceptionalWillpower;
      state.exceptionalAgilityId = newData.exceptionalAgilityId;
      state.exceptionalCharismaId = newData.exceptionalCharismaId;
      state.exceptionalHealthId = newData.exceptionalHealthId;
      state.exceptionalIntelligenceId = newData.exceptionalIntelligenceId;
      state.exceptionalPerceptionId = newData.exceptionalPerceptionId;
      state.exceptionalPowerId = newData.exceptionalPowerId;
      state.exceptionalStrengthId = newData.exceptionalStrengthId;
      state.exceptionalWillpowerId = newData.exceptionalWillpowerId;
      state.tempExceptionalAgilityId = newData.tempExceptionalAgilityId;
      state.tempExceptionalCharismaId = newData.tempExceptionalCharismaId;
      state.tempExceptionalHealthId = newData.tempExceptionalHealthId;
      state.tempExceptionalIntelligenceId =
        newData.tempExceptionalIntelligenceId;
      state.tempExceptionalPerceptionId = newData.tempExceptionalPerceptionId;
      state.tempExceptionalPowerId = newData.tempExceptionalPowerId;
      state.tempExceptionalStrengthId = newData.tempExceptionalStrengthId;
      state.tempExceptionalWillpowerId = newData.tempExceptionalWillpowerId;
    },
    setDBExceptionals: (
      state: ExceptionalStore,
      newData: { name: string; level: number; id: number }
    ) => {
      const idName = newData.name + "Id";
      state[newData.name as keyof ExceptionalStore] = newData.level;
      state[idName as keyof ExceptionalStore] = newData.id;
    },
    setExceptionalAgility: (state: ExceptionalStore, newData: number) => {
      state.exceptionalAgility = newData;
    },
    setExceptionalCharisma: (state: ExceptionalStore, newData: number) => {
      state.exceptionalCharisma = newData;
    },
    setExceptionalHealth: (state: ExceptionalStore, newData: number) => {
      state.exceptionalHealth = newData;
    },
    setExceptionalIntelligence: (state: ExceptionalStore, newData: number) => {
      state.exceptionalIntelligence = newData;
    },
    setExceptionalPerception: (state: ExceptionalStore, newData: number) => {
      state.exceptionalPerception = newData;
    },
    setExceptionalPower: (state: ExceptionalStore, newData: number) => {
      state.exceptionalPower = newData;
    },
    setExceptionalStrength: (state: ExceptionalStore, newData: number) => {
      state.exceptionalStrength = newData;
    },
    setExceptionalWillpower: (state: ExceptionalStore, newData: number) => {
      state.exceptionalWillpower = newData;
    },
    setTempExceptionalAgility: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalAgility = newData;
    },
    setTempExceptionalCharisma: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalCharisma = newData;
    },
    setTempExceptionalHealth: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalHealth = newData;
    },
    setTempExceptionalIntelligence: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalIntelligence = newData;
    },
    setTempExceptionalPerception: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalPerception = newData;
    },
    setTempExceptionalPower: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalPower = newData;
    },
    setTempExceptionalStrength: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalStrength = newData;
    },
    setTempExceptionalWillpower: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalWillpower = newData;
    },
    setExceptionalAgilityId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalAgilityId = newData;
    },
    setExceptionalCharismaId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalCharismaId = newData;
    },
    setExceptionalHealthId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalHealthId = newData;
    },
    setExceptionalIntelligenceId: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.exceptionalIntelligenceId = newData;
    },
    setExceptionalPerceptionId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalPerceptionId = newData;
    },
    setExceptionalPowerId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalPowerId = newData;
    },
    setExceptionalStrengthId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalStrengthId = newData;
    },
    setExceptionalWillpowerId: (state: ExceptionalStore, newData: number) => {
      state.exceptionalWillpowerId = newData;
    },
    setTempExceptionalAgilityId: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalAgilityId = newData;
    },
    setTempExceptionalCharismaId: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalCharismaId = newData;
    },
    setTempExceptionalHealthId: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalHealthId = newData;
    },
    setTempExceptionalIntelligenceId: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalIntelligenceId = newData;
    },
    setTempExceptionalPerceptionId: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalPerceptionId = newData;
    },
    setTempExceptionalPowerId: (state: ExceptionalStore, newData: number) => {
      state.tempExceptionalPowerId = newData;
    },
    setTempExceptionalStrengthId: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalStrengthId = newData;
    },
    setTempExceptionalWillpowerId: (
      state: ExceptionalStore,
      newData: number
    ) => {
      state.tempExceptionalWillpowerId = newData;
    },
  },
  actions: {
    clearExceptionals: (context: any) => {
      context.commit("setExceptionalAgility", 0);
      context.commit("setExceptionalHealth", 0);
      context.commit("setExceptionalStrength", 0);
      context.commit("setExceptionalIntelligence", 0);
      context.commit("setExceptionalPower", 0);
      context.commit("setExceptionalWillpower", 0);
      context.commit("setExceptionalCharisma", 0);
      context.commit("setExceptionalPerception", 0);
      context.commit("setTempExceptionalAgility", 0);
      context.commit("setTempExceptionalHealth", 0);
      context.commit("setTempExceptionalStrength", 0);
      context.commit("setTempExceptionalIntelligence", 0);
      context.commit("setTempExceptionalPower", 0);
      context.commit("setTempExceptionalWillpower", 0);
      context.commit("setTempExceptionalCharisma", 0);
      context.commit("setTempExceptionalPerception", 0);
      context.commit("setExceptionalAgilityId", 0);
      context.commit("setExceptionalHealthId", 0);
      context.commit("setExceptionalStrengthId", 0);
      context.commit("setExceptionalIntelligenceId", 0);
      context.commit("setExceptionalPowerId", 0);
      context.commit("setExceptionalWillpowerId", 0);
      context.commit("setExceptionalCharismaId", 0);
      context.commit("setExceptionalPerceptionId", 0);
      context.commit("setTempExceptionalAgilityId", 0);
      context.commit("setTempExceptionalHealthId", 0);
      context.commit("setTempExceptionalStrengthId", 0);
      context.commit("setTempExceptionalIntelligenceId", 0);
      context.commit("setTempExceptionalPowerId", 0);
      context.commit("setTempExceptionalWillpowerId", 0);
      context.commit("setTempExceptionalCharismaId", 0);
      context.commit("setTempExceptionalPerceptionId", 0);
    },
    putExceptionalAgility: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalAgilityId,
        character_id: newData.character_id,
        name: "exceptionalAgility",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalAgility", newData.value);
        context.commit("setExceptionalAgilityId", response.data[0].id);
      });
    },
    putExceptionalCharisma: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalCharismaId,
        character_id: newData.character_id,
        name: "exceptionalCharisma",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalCharisma", newData.value);
        context.commit("setExceptionalCharismaId", response.data[0].id);
      });
    },
    putExceptionalHealth: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalHealthId,
        character_id: newData.character_id,
        name: "exceptionalHealth",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalHealth", newData.value);
        context.commit("setExceptionalHealthId", response.data[0].id);
      });
    },
    putExceptionalIntelligence: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalIntelligenceId,
        character_id: newData.character_id,
        name: "exceptionalIntelligence",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalIntelligence", newData.value);
        context.commit("setExceptionalIntelligenceId", response.data[0].id);
      });
    },
    putExceptionalPerception: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalPerceptionId,
        character_id: newData.character_id,
        name: "exceptionalPerception",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalPerception", newData.value);
        context.commit("setExceptionalPerceptionId", response.data[0].id);
      });
    },
    putExceptionalPower: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalPowerId,
        character_id: newData.character_id,
        name: "exceptionalPower",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalPower", newData.value);
        context.commit("setExceptionalPowerId", response.data[0].id);
      });
    },
    putExceptionalStrength: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalStrengthId,
        character_id: newData.character_id,
        name: "exceptionalStrength",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalStrength", newData.value);
        context.commit("setExceptionalStrengthId", response.data[0].id);
      });
    },
    putExceptionalWillpower: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.exceptionalWillpowerId,
        character_id: newData.character_id,
        name: "ExceptionalWillpower",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setExceptionalWillpower", newData.value);
        context.commit("setExceptionalWillpowerId", response.data[0].id);
      });
    },
    putTempExceptionalAgility: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalAgilityId,
        character_id: newData.character_id,
        name: "tempExceptionalAgility",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalAgility", newData.value);
        context.commit("setTempExceptionalAgilityId", response.data[0].id);
      });
    },
    putTempExceptionalCharisma: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalCharismaId,
        character_id: newData.character_id,
        name: "tempExceptionalCharisma",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalCharisma", newData.value);
        context.commit("setTempExceptionalCharismaId", response.data[0].id);
      });
    },
    putTempExceptionalHealth: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalHealthId,
        character_id: newData.character_id,
        name: "tempExceptionalHealth",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalHealth", newData.value);
        context.commit("setTempExceptionalHealthId", response.data[0].id);
      });
    },
    putTempExceptionalIntelligence: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalIntelligenceId,
        character_id: newData.character_id,
        name: "tempExceptionalIntelligence",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalIntelligence", newData.value);
        context.commit("setTempExceptionalIntelligenceId", response.data[0].id);
      });
    },
    putTempExceptionalPerception: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalPerceptionId,
        character_id: newData.character_id,
        name: "tempExceptionalPerception",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalPower", newData.value);
        context.commit("setTempExceptionalPowerId", response.data[0].id);
      });
    },
    putTempExceptionalPower: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalPowerId,
        character_id: newData.character_id,
        name: "tempExceptionalPower",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalPower", newData.value);
        context.commit("setTempExceptionalPowerId", response.data[0].id);
      });
    },
    putTempExceptionalStrength: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalStrengthId,
        character_id: newData.character_id,
        name: "tempExceptional",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalStrength", newData.value);
        context.commit("setTempExceptionalStrengthId", response.data[0].id);
      });
    },
    putTempExceptionalWillpower: (
      context: any,
      newData: { value: string; character_id: string }
    ) => {
      const push = {
        id: context.getters.tempExceptionalWillpowerId,
        character_id: newData.character_id,
        name: "tempExceptionalWillpower",
        level: parseInt(newData.value),
      };
      putExceptional(push).then((response) => {
        context.commit("setTempExceptionalWillpower", newData.value);
        context.commit("setTempExceptionalWillpowerId", response.data[0].id);
      });
    },
  },
};
